import { render, staticRenderFns } from "./subscribeList.vue?vue&type=template&id=bd0c0820"
import script from "./subscribeList.vue?vue&type=script&lang=js"
export * from "./subscribeList.vue?vue&type=script&lang=js"
import style0 from "./subscribeList.vue?vue&type=style&index=0&id=bd0c0820&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports